import { useEffect, useState } from "react"
import { useLocation, useParams, useSearchParams } from "react-router-dom"
import { Box, Stack, ToggleButton } from "@mui/material"
import { Tooltip } from "@mui/material"
import { Paper } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { setCurArch } from "@/UDTreat/udTreatSlice"
import { preview, viewControlInTreatment, wasmModule } from "@/gluelayer"
import { useMyNavigation } from "@/hooks/useMyNavigation"
import { ZoomBar } from "@/UDTreat/Order/TopComponent/ZoomBar"
import { useTranslation } from "react-i18next"

import NewUpperIcon from "@/UDTreat/assets/toptoolbar_1_0/upper.svg"
import NewLowerIcon from "@/UDTreat/assets/toptoolbar_1_0/lower.svg"

import { ReactSVG } from "react-svg"

import { usePageWidth } from "@/UDTreat/top/GetViewWidth"
import { EArchType } from "@/gluelayer"
import { PatientNameID } from "@/UDTreat/top/PatientNameID"
export function TopOrderPrint() {
  // window innerWidth
  const windowWidth = usePageWidth()

  const { t } = useTranslation("common")
  const theme = useTheme()
  const navigate = useMyNavigation()
  const dispatch = useAppDispatch()
  const { caseId, patientId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()
  const {
    curArch,
    isCreateNewRefinement,
    openReviewPrint,
    openLabelPreview,
    openUndercutPreview,
    openTrimPreview,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const {
    clinicalSettings: { NumberSystem },
  } = useAppSelector((state: RootState) => state.userService)
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { caseDisposition, upperType, lowerType, uassist_progress } = caseDetail

  const [showCaseUpdatedModal, setShowcaseUpdatedModal] = useState(false)

  const location = useLocation()
  const { fileHistory } = useAppSelector(
    (state: RootState) => state.clinicalService,
  )

  const {
    patientData: { firstName = "", lastName = "" },
  } = useAppSelector((state: RootState) => {
    return state.patientService
  })

  const refineObj1 = isCreateNewRefinement
    ? { position: "absolute", left: "120px" }
    : {}
  const refineObj2 = isCreateNewRefinement
    ? { position: "absolute", left: "460px" }
    : {}

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) {
      if (preview.isInitPreview()) {
        if (curArch === "all") preview.changeArchMode("both")
        else if (curArch === "up") preview.changeArchMode("up")
        else if (curArch === "low") preview.changeArchMode("low")
      }
      return
    }
    if (curArch === "all") viewControlInTreatment.showArchMode("all")
    else if (curArch === "up") viewControlInTreatment.showArchMode("up")
    else if (curArch === "low") viewControlInTreatment.showArchMode("low")
  }, [curArch])
  const onClickUpperLower = (upper: boolean) => {
    const nextArch = upper
      ? curArch === "up"
        ? "all"
        : "up"
      : curArch === "low"
      ? "all"
      : "low"
    dispatch(setCurArch(nextArch))
  }
  const onClickUpperLowerPreview = (upper: boolean) => {
    const nextArch = upper ? "up" : "low"
    dispatch(setCurArch(nextArch))
  }
  const getArchString = () => {
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)
    if (hasUpper && hasLower) {
      return "all"
    }
    if (hasUpper && !hasLower) {
      return "up"
    }
    if (!hasUpper && hasLower) {
      return "low"
    }
    return "all"
  }
  // arch : only up or only low or all
  const [hasAllArch, setHasAllArch] = useState<string>("all")
  useEffect(() => {
    const archType = getArchString()
    setHasAllArch(archType)
    dispatch(setCurArch(archType))
  }, [])

  useEffect(() => {
    if (openLabelPreview || openTrimPreview || openUndercutPreview) {
      if (hasAllArch === "all") {
        dispatch(setCurArch("up"))
      }
    }
  }, [openLabelPreview, openTrimPreview, openUndercutPreview])

  return (
    <Paper
      sx={{
        left: 16,
        top: 43,
        right: 16,
        height: "58px",
        backgroundColor: "transparent",
        justifyContent: "center",
        position: "absolute",
      }}
      elevation={0}
    >
      <Stack
        direction="row"
        sx={{ height: "100%" }}
        alignItems={"center"}
        spacing={1}
        justifyContent={"space-between"}
      >
        <PatientNameID
          firstName={firstName}
          lastName={lastName}
          caseId={caseId}
          patientId={patientId}
          creatDate={
            caseDetail.createDate
              ? `${caseDetail.createDate.substring(
                  5,
                  7,
                )}/${caseDetail.createDate.substring(
                  8,
                  10,
                )}/${caseDetail.createDate.substring(2, 4)}`
              : ""
          }
        />

        <Box
          sx={{
            position: "absolute",
            left: "20%",
            display: "flex",
            marginLeft: "-106px !important",
          }}
        >
          {!openReviewPrint && hasAllArch === "all" && (
            <Stack
              sx={{
                height: "48px",
                borderRadius: "8px",
                backgroundColor: theme.transBkColor.light,
                boxShadow: 3,
                zIndex: 20,

                ...refineObj1,
              }}
              direction={"row"}
            >
              <Tooltip
                style={{
                  backgroundColor: curArch === "up" ? "lightgray" : "",
                }}
                title="Upper"
                placement="bottom"
              >
                <ToggleButton
                  sx={{
                    border: "none",
                    borderRadius: "8px",
                    "&:hover": {
                      borderRadius: "8px",
                    },
                    "&.Mui-selected": {
                      borderRadius: "8px",
                    },
                  }}
                  value="showUpper"
                  size="large"
                  onClick={() => {
                    if (
                      openLabelPreview ||
                      openUndercutPreview ||
                      openTrimPreview
                    ) {
                      onClickUpperLowerPreview(true)
                    } else {
                      onClickUpperLower(true)
                    }
                  }}
                >
                  <ReactSVG
                    src={NewUpperIcon}
                    afterInjection={(svg) => {
                      const path = svg.getElementsByTagName("path")[0]
                      if (curArch === "up") {
                        path?.setAttribute("fill", "#215ECD")
                        path?.setAttribute("fill-opacity", "1")
                      } else {
                        path?.setAttribute("fill", "black")
                        path?.setAttribute("fill-opacity", "0.56")
                      }
                    }}
                  ></ReactSVG>
                </ToggleButton>
              </Tooltip>
              <Tooltip
                style={{
                  backgroundColor: curArch === "low" ? "lightgray" : "",
                }}
                title="Lower"
                placement="bottom"
              >
                <ToggleButton
                  sx={{
                    border: "none",
                    borderRadius: "8px",
                    "&:hover": {
                      borderRadius: "8px",
                    },
                    "&.Mui-selected": {
                      borderRadius: "8px",
                    },
                  }}
                  value="showLower"
                  size="large"
                  onClick={() => {
                    if (
                      openLabelPreview ||
                      openUndercutPreview ||
                      openTrimPreview
                    ) {
                      onClickUpperLowerPreview(false)
                    } else {
                      onClickUpperLower(false)
                    }
                  }}
                >
                  <ReactSVG
                    src={NewLowerIcon}
                    afterInjection={(svg) => {
                      const path = svg.getElementsByTagName("path")[0]
                      if (curArch === "low") {
                        path?.setAttribute("fill", "#215ECD")
                        path?.setAttribute("fill-opacity", "1")
                      } else {
                        path?.setAttribute("fill", "black")
                        path?.setAttribute("fill-opacity", "0.56")
                      }
                    }}
                  ></ReactSVG>
                </ToggleButton>
              </Tooltip>
            </Stack>
          )}

          <ZoomBar sx={{ marginLeft: "10px" }} />
        </Box>
      </Stack>
    </Paper>
  )
}
